export class CO2MeasurementLoadCompleted {
}
